import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { store } from '@features/redux/store';
import { theme } from '@features/theme';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AlertProvider } from '@features/contexts/AlertProvider';
import { LoadingProvider } from '@features/contexts/LoadingProvider';
import { AlertPopup } from '@components/AlertPopup';
import { GlobalLoading } from '@components/GlobalLoading';

import type { ReactNode } from 'react';

export const MainProvider = ({ children }: { children?: ReactNode }) => {
    return (
        <BrowserRouter>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <StyledEngineProvider injectFirst>
                        <AlertProvider>
                            <LoadingProvider>
                                {children}
                                <GlobalLoading />
                            </LoadingProvider>
                            <AlertPopup />
                        </AlertProvider>
                    </StyledEngineProvider>
                </ThemeProvider>
            </Provider>
        </BrowserRouter>
    );
};
